import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import Card from '../molecules/Card';

const useStyles = makeStyles((theme) => ({
  containerCard: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around',
    margin: '1em 2em',
  },
  [theme.breakpoints.down(760)]: {
    containerCard: {
      display: 'inline',
    },
  },
}));

const CardList = ({ array }) => {
  const classes = useStyles();
  return (
    <ul className={classes.containerCard}>
      {array?.map((element, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={i}>
          <Card cat={element} />
        </li>
      ))}
    </ul>
  );
};
export default CardList;

CardList.propTypes = {
  array: PropTypes.arrayOf({}),
};

CardList.defaultProps = {
  array: [
    {
      title: '',
    },
  ],
};
